export default {
  "--ck-font-family":
    '"Nunito",ui-rounded,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,"Apple Color Emoji",Arial,sans-serif,"Segoe UI Emoji","Segoe UI Symbol"',
  "--ck-border-radius": "24px",

  "--ck-connectbutton-font-size": "17px",
  "--ck-connectbutton-font-weight": "700",
  "--ck-connectbutton-border-radius": "14px",
  "--ck-connectbutton-color": "#000000",
  "--ck-connectbutton-background": "#ffffff",
  "--ck-connectbutton-box-shadow":
    "inset 0 0 0 2px #DFE4EC, 0 2px 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-connectbutton-hover-background": "#F9FAFB",

  "--ck-connectbutton-balance-color": "#414451",
  "--ck-connectbutton-balance-background": "#F9FAFB",
  "--ck-connectbutton-balance-box-shadow":
    "0 2px 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-connectbutton-balance-hover-background": "#F5F7F9",
  "--ck-connectbutton-balance-hover-box-shadow":
    "0 2px 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",
  "--ck-connectbutton-balance-active-box-shadow":
    "0 0 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-connectbutton-active-background": "#F5F7F9",
  "--ck-connectbutton-active-box-shadow":
    "inset 0 0 0 2px #CFD7E2, 0 0px 0 0 #CFD7E2, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-primary-button-border-radius": "18px",
  "--ck-primary-button-color": "#000000",
  "--ck-primary-button-background": "#ffffff",
  "--ck-primary-button-box-shadow":
    "inset 0 0 0 2px #DFE4EC, inset  0 -4px 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-primary-button-hover-background": "#F5F7F9",
  "--ck-primary-button-hover-box-shadow":
    "inset 0 0 0 2px #DFE4EC, inset  0 -2px 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-secondary-button-border-radius": "16px",
  "--ck-secondary-button-color": "#000000",
  "--ck-secondary-button-background": "#ffffff",
  "--ck-secondary-button-box-shadow":
    "inset 0 0 0 2px #DFE4EC, inset  0 -4px 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-secondary-button-hover-background": "#F5F7F9",
  "--ck-secondary-button-hover-box-shadow":
    "inset 0 0 0 2px #DFE4EC, inset  0 -2px 0 0 #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-focus-color": "#1A88F8",
  "--ck-modal-box-shadow": `0px 3px 16px rgba(0, 0, 0, 0.08)`,
  "--ck-body-color": "#000000",
  "--ck-body-color-muted": "#93989F",
  "--ck-body-color-muted-hover": "#000000",
  "--ck-body-background": "#ffffff",
  "--ck-body-background-transparent": "rgba(255,255,255,0)",
  "--ck-body-background-secondary": "#f6f7f9",
  "--ck-body-background-secondary-hover-background": "#e0e4eb",
  "--ck-body-background-secondary-hover-outline": "#4282FF",
  "--ck-body-background-tertiary": "#ffffff",
  "--ck-tertiary-border-radius": "22px",
  "--ck-tertiary-box-shadow":
    "inset 0 0 0 2px #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-body-action-color": "#93989F",
  "--ck-body-divider": "#DFE4EC",
  "--ck-body-color-danger": "#FF4E4E",
  "--ck-body-color-valid": "#32D74B",

  "--ck-body-disclaimer-background": "#F9FAFB",
  "--ck-body-disclaimer-font-size": "14px",
  "--ck-body-disclaimer-font-weight": "700",
  "--ck-body-disclaimer-color": "#959697",
  "--ck-body-disclaimer-link-color": "#646464",
  "--ck-body-disclaimer-link-hover-color": "#000000",

  "--ck-copytoclipboard-stroke": "#CCCCCC",

  "--ck-tooltip-background": "#ffffff",
  "--ck-tooltip-background-secondary": "#ffffff",
  "--ck-tooltip-color": "#999999",
  "--ck-tooltip-shadow": " 0 0 0 2px #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",

  "--ck-spinner-color": "var(--ck-focus-color)",

  "--ck-dropdown-button-color": "#999999",
  "--ck-dropdown-button-box-shadow":
    "0 0 0 2px #DFE4EC,  0 2px 0 2px #DFE4EC, 0px 2px 4px rgba(0, 0, 0, 0.02)",
  "--ck-dropdown-button-background": "#fff",

  "--ck-dropdown-button-hover-color": "#8B8B8B",
  "--ck-dropdown-button-hover-background": "#F5F7F9",

  "--ck-dropdown-pending-color": "#848D9A",
  "--ck-dropdown-active-color": "#000000",
  "--ck-dropdown-active-static-color": "#848D9A",
  "--ck-dropdown-active-background": "#F5F7F9",
  "--ck-dropdown-color": "#848D9A",
  "--ck-dropdown-background": "#FFFFFF",
  "--ck-dropdown-box-shadow": "0px 2px 15px rgba(0, 0, 0, 0.15)",
  "--ck-dropdown-border-radius": "16px",

  "--ck-alert-color": "#848D9A",
  "--ck-alert-background": "#F5F7F9",

  "--ck-qr-border-radius": "24px",
  "--ck-qr-dot-color": "#111111",
  "--ck-qr-border-color": "#DFE4EC",

  "--ck-modal-h1-font-weight": "700",
  "--ck-modal-heading-font-weight": "700",
  "--ck-primary-button-font-weight": "700",

  "--ck-recent-badge-box-shadow": "inset 0 0 0 2px currentColor",
  "--ck-recent-badge-top-offset": "0px",

  /** Graphics options for our themes, not to be exposed to devs */
  /*
  '--ck-graphic-primary-color': '#6C7381',
  '--ck-graphic-primary-background': '#ffffff',
  '--ck-graphic-primary-box-shadow': 'inset 0 0 0 2px #DFE4EC',

  '--ck-graphic-secondary-color': '#DFE4EC',
  '--ck-graphic-secondary-background': '#ffffff',
  '--ck-graphic-secondary-box-shadow': 'inset 0 0 0 2px #DFE4EC',

  '--ck-graphic-compass-color': '#ffffff',
  '--ck-graphic-compass-background': '#6C7381',
  '--ck-graphic-compass-box-shadow': 'inset 0 0 0 2px rgba(0,0,0,0.1)',

  '--ck-graphic-globe-background':
    'radial-gradient(84.37% 84.37% at 50% 15.63%, rgba(255, 255, 255, 0.2) 0%, rgba(0, 0, 0, 0) 100%), linear-gradient(180deg, #DFE4EC 0%, #DFE4EC 114.06%), #DFE4EC',
  '--ck-graphic-globe-lines': '#ffffff',
  '--ck-graphic-globe-box-shadow': 'inset 0 0 0 2px #DFE4EC',
  */

  "--ck-siwe-border": "#DFE4EC",
};
